import React,{PureComponent} from 'react';
import {connect} from 'react-redux';

import Button from 'components/Button';
import {csvUpload,toggleFormModal} from 'actions';
import {getIntegrationName} from '../../utils';
import WithNotifications from 'containers/WithNotifications';
import './upload.css';

class Upload extends PureComponent{
    onHandleChange=(e)=>{
        const reader = new FileReader();
        reader.readAsText(e.target.files[0])
        reader.onload = (ev) => {
            const file = `data:text/csv;base64,${btoa(ev.target.result)}`;
            this.props.csvUpload(file,getIntegrationName(this.props.source))
            .then(()=>{
                this.props.toggleFormModal();
                this.props.addNotification('success','CSV file uploaded successfully')
            })
            .catch(()=>this.props.addNotification('error','There was a problem uploading the CSV file, please try again'));
        }
    }
    render(){
        return (
            <div className="upload">
                <Button styling="apps-outlined">{this.props.buttonText}</Button>
                <input onChange={this.onHandleChange} multiple={this.props.multiple} type="file" accept={this.props.accept} className="upload-input"/>
            </div>
        )
    }
}

export default WithNotifications(connect(null,{csvUpload,toggleFormModal})(Upload));


// WEBPACK FOOTER //
// ./src/components/Upload/index.js